import { Flex } from "@chakra-ui/layout";
import { Alert, AlertDescription, AlertIcon } from "@chakra-ui/react";
import Markdown from "markdown-to-jsx";
import { useEditFormTemplateContext } from "../context";

type Props = {
  id: string;
};
export const ValidationAlert: React.FC<Props> = ({ id }) => {
  const { state } = useEditFormTemplateContext();
  const validations = state.get("validations").get(id);

  if (validations === undefined || validations.size === 0) {
    return null;
  }
  return (
    <Flex direction="column" gap="2">
      {validations.toArray().map((error) => (
        <Alert status="error" key={error} rounded="md">
          <AlertIcon />
          <AlertDescription>
            Error: <Markdown>{error}</Markdown>
          </AlertDescription>
        </Alert>
      ))}
    </Flex>
  );
};
